// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles-module--btn--2q4JF","white":"styles-module--white--f2UXD"};